import React, { useState, useEffect, componentDidMount } from 'react';
import _ from 'lodash-es';

window.$.fn.scrollCenter = (elem, speed) => {
  // this = #timepicker
  // elem = .active
  var active = window.$(this).find(elem);
  var activeWidth = active.width() / 1;

  var pos = active.position().left + activeWidth;
  var elpos = window.$(this).scrollLeft();
  var elW = window.$(this).width();

  pos = pos + elpos - elW / 2; // for center position if you want adjust then change this

  window.$(this).animate(
    {
      scrollLeft: pos,
    },
    speed == undefined ? 1000 : speed
  );
  return true;
};

const HeaderComponent = ({
  configData,
  currentCategory,
  outfitList,
  finalArray,
  setFinalArray,
  handleCategoryChange,
  preCatOneSection,
  preCatTwoSection,
  setcategoryChckForCallData,
}) => {
  const [Loading, SetLoading] = useState(true);
  const [headerName, SetHeaderName] = useState('');
  const [categoryTitle, SetCategoryTitle] = useState('');
  const [categoryList, SetCategoryList] = useState([]);
  const [optionalList, SetOptionalList] = useState([]);
  const [optionalListTitle, SetOptionalListTitle] = useState('');
  let selected = [];
  selected = [
    ...outfitList.map(each => each.categoryCurrent),
    ...outfitList
      .map(each => each.categoryName)
      .map(element => {
        if (element != undefined) return element.split('__')[2];
      }),
  ];

  const [selectedCategories, SetSelectedCategories] = useState([selected]);
  // console.log(outfitList, 'outfitList',selected);
  const handleCategoryClick = catName => {
    // console.log(catName, 'catName');
    handleCategoryChange(catName);
    // category anymation script is start
    window.$('.pagescroll').removeClass('active');
    window.$('#pagescrollactive').addClass('active');
    setTimeout(() => {
      window.$('#dc-header-head').scrollCenter('.active', 300);
    }, 1000);
  };

  useEffect(() => {
    // console.log(configData, 'configData');
    if (configData.length !== 0) {
      // console.log('here')
      const categoryList =
        configData.default_categories &&
        configData.default_categories.map(each => each.display_name);
      const optionalList =
        configData.possible_categories &&
        configData.possible_categories.map(each => each.display_name);
      SetCategoryList(categoryList);
      SetOptionalList(optionalList);
      if (configData.possible_categories != undefined) {
        setcategoryChckForCallData([
          ...configData.default_categories,
          ...configData.possible_categories,
        ]);
      } else {
        setcategoryChckForCallData([...configData.default_categories]);
      }
      let selectedCats = [];
      if (configData.input && configData.input.product_selections)
        selectedCats = Object.keys(configData.input.product_selections);
      SetSelectedCategories(selectedCats);
      SetHeaderName(configData.input && configData.input.builder_name);
      SetCategoryTitle(
        configData.configurator === undefined
          ? 'Outfit Categories'
          : configData.configurator.default_categories_heading === ''
          ? 'Outfit Categories'
          : configData.configurator.default_categories_heading
      );
      SetOptionalListTitle(
        configData.configurator === undefined
          ? 'Optional Categories'
          : configData.configurator.dynamic_addons_heading
      );
      SetLoading(false);
    } else {
      // console.log('no config returned');
      SetCategoryList(preCatOneSection.map(e => e));
      // SetOptionalList(preCatTwoSection.map(e => e));
      // alert(1);
      // console.log(configData, 'configData');
      SetLoading(false);
    }

    selected = selected.filter(e => e != undefined);
  }, [configData]);
  useEffect(() => {
    setFinalArray(selected.filter(eUndefind => eUndefind != undefined));
  }, []);

  window.$(window).resize(function() {
    var x = document.getElementById('desktop-outfit');
    var y = document.getElementById('left-bar');

    if (window.$(window).width() >= '1100') {
      /* x.style.display = 'initial';
      x.style.transition = 'initial';
      x.style.height = 'initial';
      y.style.display = 'initial';
      y.style.transition = 'initial';*/
      window.$('#desktop-outfit').attr({ style: '' });
      window.$('#desktop-outfit .outfit-footer').attr({ style: '' });
      window.$('#left-bar').attr({ style: '' });
    }
  });

  //var navScroll = window.$('#dc-header-head').width();
  // console.log(selected, 'selected');

  const OptionalCategories = Loading ? (
    <p>Loading</p>
  ) : (
    <>
      <div>
        <label className="category-header">{optionalListTitle}</label>
        <div className="category-labels-list">
          {optionalList &&
            optionalList.map((each, index) => {
              let labelclassName = 'category-label';
              const isAdded = selected.find(
                cat => cat === each && cat != undefined
              );
              //const isAdded = selectedCategories.find(cat => cat === each);
              if (isAdded != undefined) {
                labelclassName = 'category-label category-label-added';
              }
              let currentActive = 'pagescroll';
              let currentActivecase = '';
              if (currentCategory !== undefined && currentCategory === each) {
                labelclassName = 'category-label category-label-active';
                currentActive = 'pagescroll active';
                currentActivecase = 'pagescrollactive';
              }
              return (
                <div
                  key={index}
                  style={{ display: 'flex' }}
                  className={currentActive}
                  id={currentActivecase}
                  onClick={() => handleCategoryClick(each)} //-- TODO - this will be uncommented once we allow category navigation
                >
                  {isAdded != undefined && isAdded === each ? (
                    <div className="tickbg-white">
                      <div className="tickbg-dark">
                        <div className="tick"></div>
                      </div>
                    </div>
                  ) : null}
                  <label className={labelclassName}>
                    {each ? each.toLowerCase() : each}
                  </label>
                </div>
              );
            })}{' '}
        </div>
      </div>
    </>
  );

  const Outfitcategories = Loading ? (
    <p>Loading</p>
  ) : (
    <>
      <div>
        <label className="category-header">{categoryTitle}</label>
        <div className="category-labels-list">
          {categoryList &&
            categoryList.map((each, index) => {
              let labelclassName = 'category-label';
              const isAdded = selected.find(
                cat => cat === each && cat != undefined
              );
              //const isAdded = selectedCategories.find(cat => cat === each);
              //console.log(isAdded)
              if (isAdded != undefined) {
                labelclassName = 'category-label category-label-added';
              }
              let currentActive = 'pagescroll';
              let currentActivecase = '';
              if (currentCategory != undefined && currentCategory === each) {
                labelclassName = 'category-label category-label-active';
                currentActive = 'pagescroll active';
                currentActivecase = 'pagescrollactive';
              }
              return (
                <div
                  key={index}
                  style={{ display: 'flex' }}
                  className={currentActive}
                  id={currentActivecase}
                  onClick={() => handleCategoryClick(each)}
                >
                  {isAdded != undefined && isAdded === each ? (
                    <div className="tickbg-white">
                      <div className="tickbg-dark">
                        <div className="tick"></div>
                      </div>
                    </div>
                  ) : null}
                  <label className={labelclassName}>
                    {each ? each.toLowerCase() : each}
                  </label>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );

  return (
    <div className="dc-header">
      <h1>{headerName}</h1>
      <div className="dc-header-head" id="dc-header-head">
        {Outfitcategories}
        <span className="navdivder"></span>
        {optionalList && optionalList.length > 0 && !optionalList.includes(null)
          ? OptionalCategories
          : null}
      </div>
    </div>
  );
};
export default HeaderComponent;
